import CpeOrderCard from '@/components/pages/ManageOrder/components/CpeOrderCard/CpeOrderCard'
import { CpeOrder, OrderDetail } from '@/api'

type CpeOrderCardContainerProps = {
  orderData: OrderDetail
  cpeOrderData: CpeOrder
}

const CpeOrderCardContainer = ({ cpeOrderData, orderData }: CpeOrderCardContainerProps) => {
  const handleTrackPackage = (uri: string) => {
    window.open(uri, '_blank')
  }

  return <CpeOrderCard cpeOrderData={cpeOrderData} handleTrackPackage={handleTrackPackage} orderData={orderData} />
}

export default CpeOrderCardContainer
